import React from 'react';
import { CONTACTS } from '../Constants';

const Contact = () => {
  return (
    <section id='contact' className='w-full flex flex-col justify-center bg-gradient-to-r from-blue-400 to-purple-600 items-center p-4'>
      <h1 className='text-2xl font-bold mb-4'>Contact</h1>
      <div className='flex flex-col md:flex-row justify-center items-center md:gap-2 lg:gap-3'>
        {CONTACTS.map((item, i) => (
          <div
            key={i}
            className='flex flex-row justify-center items-center rounded gap-2 p-3 mb-2 md:p-2 lg:p-4 shadow-lg bg-gradient-to-r from-blue-400 to-purple-600 hover:shadow-lg transition-shadow duration-300'
          >
            <img
              src={item.icon}
              alt={`${item.type} icon`}
              className='w-6 h-6 md:w-8 md:h-8' // Adjust icon size for medium screens
            />
            <a href={item.Link} className='text-gray-800 hover:underline text-sm md:text-base'>
              {item.type}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Contact;
 